// extracted by mini-css-extract-plugin
export default {"card":"styles_card__+1MX8","item_text":"styles_item_text__ZpAJa","item_icon":"styles_item_icon__RTnTr","weight":"styles_weight__zp0Sc","item_code":"styles_item_code__HAoyG"};